import { Dayjs } from 'dayjs';

export const getDaysInMonth = (date?: Dayjs): number => (date ? date.daysInMonth() : 0);
